import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';
import getCookieConsentConfig from './cookieConsentConfig';
import { sleep } from '@raiden-corp/rc-kit/utils';

export const initializeCookieConsent = async () => {
  await sleep(4000);
  CookieConsent.run(getCookieConsentConfig());
};
